var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 7.99992C14.6666 11.6818 11.6818 14.6666 7.99992 14.6666C4.31802 14.6666 1.33325 11.6818 1.33325 7.99992C1.33325 4.31802 4.31802 1.33325 7.99992 1.33325C11.6818 1.33325 14.6666 4.31802 14.6666 7.99992Z",
    fill: "#1D2939"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00033 3.41675L3.41699 11.3334H12.5837L8.00033 3.41675Z",
    fill: "#EAB83E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00024 3C8.14893 3 8.28634 3.07923 8.36084 3.2079L12.9442 11.1246C13.0188 11.2535 13.0189 11.4124 12.9445 11.5415C12.8701 11.6705 12.7325 11.75 12.5836 11.75H3.41691C3.26796 11.75 3.13034 11.6705 3.05594 11.5415C2.98154 11.4124 2.98169 11.2535 3.05632 11.1246L7.63965 3.2079C7.71415 3.07923 7.85156 3 8.00024 3ZM4.1396 10.9167H11.8609L8.00024 4.24828L4.1396 10.9167Z",
    fill: "#101828"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99992 9.25024C8.23004 9.25024 8.41659 9.43679 8.41659 9.66691V9.87524C8.41659 10.1054 8.23004 10.2919 7.99992 10.2919C7.7698 10.2919 7.58325 10.1054 7.58325 9.87524V9.66691C7.58325 9.43679 7.7698 9.25024 7.99992 9.25024Z",
    fill: "#101828"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99957 5.91675C8.22969 5.91656 8.41639 6.10295 8.41659 6.33307L8.41831 8.4163C8.41851 8.64642 8.23211 8.83312 8.00199 8.83331C7.77188 8.8335 7.58517 8.64711 7.58498 8.41699L7.58325 6.33376C7.58306 6.10364 7.76945 5.91694 7.99957 5.91675Z",
    fill: "#101828"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.c0286bcd4d5c944f79bf432ab655d3d3.svg";
export { ForwardRef as ReactComponent };